import apiClient from './axios';
import { ApiResponse } from '../types';

/**
 * The money figures Ibra quotes as current — the policy rate, the dollar,
 * T-bill yields, inflation. Mirrors `admin/money-facts` on the backend.
 *
 * A figure is given to Ibra only with a value *and* the date it was true;
 * clearing the value withdraws it.
 */
export interface MoneyFact {
  key: string;
  label: string;
  value: string | null;
  /** `YYYY-MM-DD`: the day the figure was true, not the day it was typed. */
  asOf: string | null;
  source: string | null;
  /** Where the figure is published. */
  hint: string | null;
  sortOrder: number;
  updatedAt: string;
}

export interface UpdateMoneyFactDto {
  value?: string;
  asOf?: string;
  source?: string;
}

/** Older than this and Ibra quotes the figure as possibly out of date. */
export const STALE_AFTER_DAYS = 45;

export const moneyFactsApi = {
  list: async () => {
    const { data } = await apiClient.get<ApiResponse<MoneyFact[]>>('/admin/money-facts');
    return data.data;
  },
  update: async (key: string, dto: UpdateMoneyFactDto) => {
    const { data } = await apiClient.patch<ApiResponse<MoneyFact>>(
      `/admin/money-facts/${encodeURIComponent(key)}`,
      dto,
    );
    return data.data;
  },
};
